

function NoDataFound(){

    return (
        <div className="w-100">
            <h4 className="text-danger text-center mt-2 ">No Data Found</h4>
        </div>
    )

}

export default NoDataFound